<template>
	<div>
		<el-row :gutter="20" v-if="row.processKey=='attractInvestmentManage'">
			<el-col :span="12">
				<span>品牌方名称 :</span>
				<span>{{row.name}}</span>
			</el-col>
			<el-col :span="12">
				<span>品牌信息 :</span>
				<span>{{row.info}}</span>
			</el-col>
			<el-col :span="12">
				<span>品牌描述 :</span>
				<span>{{row.describe}}</span>
			</el-col>
			<el-col :span="12">
				<span>品牌方联系人 :</span>
				<span>{{row.contacts}}</span>
			</el-col>
			<el-col :span="12">
				<span>联系电话 :</span>
				<span>{{row.phone}}</span>
			</el-col>
			<el-col :span="12">
				<span>申请时间 :</span>
				
				<span>{{setTime(row.createTime)}}</span>
			</el-col>
			<!-- <el-col :span="12">
				<span>申请人名称 :</span>
				<span>{{row.applicantName}}</span>
			</el-col>
			<el-col :span="12">
				<span>审批人名称 :</span>
				<span>{{row.approvalPersonName}}</span>
			</el-col>
			<el-col :span="12">
				<span>审批时间 :</span>
				<span>{{row.approvalTime}}</span>
			</el-col>
			<el-col :span="12">
				<span>审核状态 :</span>
				<span>{{row.status}}</span>
			</el-col>
			<el-col :span="12">
				<span>原因 :</span>
				<span>{{row.reason}}</span>
			</el-col> -->
			<el-col :span="24">
				<span>附件 :</span>
				<span>{{row.fileName}}</span>
			</el-col>
		</el-row>
		<el-row :gutter="20" v-if="row.processKey=='meetingProcess'">
			<el-col :span="12">
				<span>申请人 :</span>
				<span>{{row.name}}</span>
			</el-col>
			<el-col :span="12">
				<span>手机号 :</span>
				<span>{{row.phone}}</span>
			</el-col>
			<el-col :span="12">
				<span>房间号 :</span>
				<span>{{row.roomNumber}}</span>
			</el-col>
			<el-col :span="12">
				<span>会议室号 :</span>
				<span>{{row.number}}</span>
			</el-col>
			<el-col :span="12">
				<span>开始时间 :</span>
				<span>{{row.startTime}}</span>
			</el-col>
			<el-col :span="12">
				<span>结束时间 :</span>
				<span>{{row.endTime}}</span>
			</el-col>
			<el-col :span="12">
				<span>用时 :</span>
				<span>{{row.hours}}</span>
			</el-col>
			<el-col :span="12">
				<span>说明 :</span>
				<span>{{row.explains}}</span>
			</el-col>
		</el-row>
		<el-row :gutter="20" v-if="row.processKey=='contractChange'">
			<el-col :span="12">
				<span>合同编号 :</span>
				<span>{{row.number}}</span>
			</el-col>
			<el-col :span="12">
				<span>所属楼层 :</span>
				<span>{{row.floor}}</span>
			</el-col>
			<el-col :span="12">
				<span>商铺号 :</span>
				<span>{{row.shops}}</span>
			</el-col>
			<el-col :span="12">
				<span>业态标签 :</span>
				<span>{{row.formatsTags}}</span>
			</el-col>
			<el-col :span="12">
				<span>品牌名称 :</span>
				<span>{{row.brandName}}</span>
			</el-col>
			<el-col :span="12">
				<span>签约时间 :</span>
				<span>{{row.qianyueTime}}</span>
			</el-col>
			<el-col :span="12">
				<span>到期时间 :</span>
				<span>{{row.endingTime}}</span>
			</el-col>
			<el-col :span="12">
				<span>合同名称 :</span>
				<span>{{row.contractName}}</span>
			</el-col>
			<el-col :span="12">
				<span>合同期限 :</span>
				<span>{{row.contactLimit}}</span>
			</el-col>
			<el-col :span="12">
				<span>付款周期 :</span>
				<span>{{row.paymentCycle}}</span>
			</el-col>
			<el-col :span="12">
				<span>品牌联系人 :</span>
				<span>{{row.linkName}}</span>
			</el-col>
			<el-col :span="12">
				<span>联系电话 :</span>
				<span>{{row.linkPhone}}</span>
			</el-col>
			<el-col :span="12">
				<span>品牌描述 :</span>
				<span>{{row.linkDescribe}}</span>
			</el-col>
			<el-col :span="12">
				<span>合同状态 :</span>
				<span>{{row.contractStatus}}</span>
			</el-col>
			<el-col :span="12">
				<span>审核状态 :</span>
				<span>{{row.applyStatus}}</span>
			</el-col>
			<el-col :span="12">
				<span>补充协议 :</span>
				<span>{{row.extraXieyi}}</span>
			</el-col>
			<el-col :span="12">
				<span>解约原因 :</span>
				<span>{{row.terminationReason}}</span>
			</el-col>
			<el-col :span="12">
				<span>创建时间 :</span>
				<span>{{row.createTime}}</span>
			</el-col>
			<el-col :span="12">
				<span>创建人 :</span>
				<span>{{row.createName}}</span>
			</el-col>
			<el-col :span="12">
				<span>合同附件路径 :</span>
				<span>{{row.contractAttachmentFilename}}</span>
			</el-col>
		</el-row>
		<el-row :gutter="20" v-if="row.processKey=='renovationProcess'">
			<el-col :span="12">
				<span>商铺号 :</span>
				<span>{{row.shopNum}}</span>
			</el-col>
			<el-col :span="12">
				<span>商铺名称 :</span>
				<span>{{row.shopName}}</span>
			</el-col>
			<el-col :span="12">
				<span>申请人名称 :</span>
				<span>{{row.applyName}}</span>
			</el-col>
			<el-col :span="12">
				<span>联系电话 :</span>
				<span>{{row.phone}}</span>
			</el-col>
			<el-col :span="12">
				<span>装修开始时间 :</span>
				<span>{{row.startTime}}</span>
			</el-col>
			<el-col :span="12">
				<span>装修结束时间 :</span>
				<span>{{row.endTime}}</span>
			</el-col>
			<el-col :span="12">
				<span>每天装修时间段 :</span>
				<span>{{row.timeSlot}}</span>
			</el-col>
			<el-col :span="12">
				<span>工期 :</span>
				<span>{{row.constructionPeriod}}</span>
			</el-col>
			<el-col :span="12">
				<span>描述 :</span>
				<span>{{row.describes}}</span>
			</el-col>
			<el-col :span="12">
				<span>商管拒绝原因 :</span>
				<span>{{row.bmReason}}</span>
			</el-col>
			<el-col :span="12">
				<span>物业审核结果 :</span>
				<span>{{row.bmApprovalTime}}</span>
			</el-col>
			<el-col :span="12">
				<span>物业拒绝原因 :</span>
				<span>{{row.pmReason}}</span>
			</el-col>
			<el-col :span="12">
				<span>总审核结果 :</span>
				<span>{{row.result}}</span>
			</el-col>
			<el-col :span="12">
				<span>创建时间 :</span>
				<span>{{row.createTime}}</span>
			</el-col>
			<slot name="zhuangxiu"></slot>
		</el-row>
		<el-row :gutter="20" v-if="row.processKey=='shopReturnProcess'">
			<el-col :span="12">
				<span>商铺号 :</span>
				<span>{{row.shopNum}}</span>
			</el-col>
			<el-col :span="12">
				<span>商铺名称 :</span>
				<span>{{row.shopName}}</span>
			</el-col>
			<el-col :span="12">
				<span>申请人名称 :</span>
				<span>{{row.applyName}}</span>
			</el-col>
			<el-col :span="12">
				<span>联系电话 :</span>
				<span>{{row.phone}}</span>
			</el-col>
			<el-col :span="12">
				<span>申请时间 :</span>
				<span>{{row.applyTime}}</span>
			</el-col>
			<el-col :span="12">
				<span>退租原因 :</span>
				<span>{{row.returnReason}}</span>
			</el-col>
			<el-col :span="12">
				<span>审核结果 :</span>
				<span>{{row.result}}</span>
			</el-col>
			<el-col :span="12">
				<span>拒绝原因 :</span>
				<span>{{row.reason}}</span>
			</el-col>
			<el-col :span="12">
				<span>类型 :</span>
				<span>{{row.type}}</span>
			</el-col>
			<el-col :span="12">
				<span>创建时间 :</span>
				<span>{{row.createTime}}</span>
			</el-col>
			<slot name="tuizu"></slot>
		</el-row>
		<el-row :gutter="20" v-if="row.processKey=='visitProcess'">
			<el-col :span="12">
				<span>来访人住址 :</span>
				<span>{{row.address}}</span>
			</el-col>
			<el-col :span="12">
				<span>来访人年龄 :</span>
				<span>{{row.age}}</span>
			</el-col>
			<el-col :span="12">
				<span>性别 :</span>
				<span>{{row.sex}}</span>
			</el-col>
			<el-col :span="12">
				<span>离开时间 :</span>
				<span>{{row.departureTime}}</span>
			</el-col>
			<el-col :span="12">
				<span>被访人姓名 :</span>
				<span>{{row.intervieweeName}}</span>
			</el-col>
			<el-col :span="12">
				<span>房间号 :</span>
				<span>{{row.roomNumber}}</span>
			</el-col>
			<el-col :span="12">
				<span>来访人 :</span>
				<span>{{row.visitor}}</span>
			</el-col>
			<el-col :span="12">
				<span>来访时间 :</span>
				<span>{{row.visitingTime}}</span>
			</el-col>
			<el-col :span="12">
				<span>来访原因 :</span>
				<span>{{row.reason}}</span>
			</el-col>
			<el-col :span="12">
				
			</el-col>
			<!-- <el-col :span="12">
				<span>健康码存储路径 :</span>
				<span>{{row.healthPath}}</span>
			</el-col> -->
			<el-col :span="12">
				<div style="display: flex;align-items: center;">
					<span>健康码展示路径 :</span>
					<img style="width: 50px;" :src="row.showHealthPath">
				</div>
				<!-- 	<span>{{row.showHealthPath}}</span> -->
			</el-col>
			<el-col :span="12">
				<div style="display: flex;align-items: center;">
					<span>行程码展示路径 :</span>
					<img style="width: 50px;" :src="row.showTripPath">
				</div>

				<!-- <span>{{row.showTripPath}}</span> -->
			</el-col>
			<!-- <el-col :span="12">
				<span>行程码存储路径 :</span>
				<span>{{row.tripPath}}</span>
			</el-col> -->
		</el-row>
		<el-row :gutter="20" v-if="row.processKey=='subscribeLookProcess'">
			<el-col :span="12">
				<span>单位 :</span>
				<span>{{row.company}}</span>
			</el-col>
			<el-col :span="12">
				<span>预约时间 :</span>
				<span>{{row.lookDate}}</span>
			</el-col>
			<el-col :span="12">
				<span>预约日期 :</span>
				<span>{{row.lookTime}}</span>
			</el-col>
			<el-col :span="12">
				<span>名称 :</span>
				<span>{{row.name}}</span>
			</el-col>
			<el-col :span="12">
				<span>联系电话 :</span>
				<span>{{row.phone}}</span>
			</el-col>
			<el-col :span="12">
				<span>要求 :</span>
				<span>{{row.requires}}</span>
			</el-col>
			<el-col :span="12">
				<span>房间号 :</span>
				<span>{{row.roomNumber}}</span>
			</el-col>
		</el-row>
		<el-row :gutter="20" v-if="row.processKey=='materialApplyProcess'">
			<el-col :span="12">
				<span>申办人 :</span>
				<span>{{row.applyName}}</span>
			</el-col>
			<el-col :span="12">
				<span>确认方式 :</span>
				<span>{{row.confirmMethod}}</span>
			</el-col>
			<el-col :span="12">
				<span>部门经手人 :</span>
				<span>{{row.deptPerson}}</span>
			</el-col>
			<el-col :span="12">
				<span>驾驶证号 :</span>
				<span>{{row.driverLicense}}</span>
			</el-col>
			<el-col :span="12">
				<span>证件号 :</span>
				<span>{{row.idCard}}</span>
			</el-col>
			<el-col :span="12">
				<span>发证机关 :</span>
				<span>{{row.issuingAuthority}}</span>
			</el-col>
			<el-col :span="12">
				<span>车牌号 :</span>
				<span>{{row.licensePlate}}</span>
			</el-col>
			<el-col :span="12">
				<span>车型 :</span>
				<span>{{row.model}}</span>
			</el-col>
			<el-col :span="12">
				<span>其他证件 :</span>
				<span>{{row.otherNum}}</span>
			</el-col>
			<el-col :span="12">
				<span>业主 :</span>
				<span>{{row.ownerName}}</span>
			</el-col>
			<el-col :span="12">
				<span>搬离原因 :</span>
				<span>{{row.reason}}</span>
			</el-col>
			<el-col :span="12">
				<span>房间性质 :</span>
				<span>{{row.roomNature}}</span>
			</el-col>
			<el-col :span="12">
				<span>房间号 :</span>
				<span>{{row.roomNumber}}</span>
			</el-col>
			<el-col :span="12">
				<span>安全员 :</span>
				<span>{{row.safetyOfficer}}</span>
			</el-col>
			<el-col :span="12">
				<span>颜色 :</span>
				<span>{{row.color}}</span>
			</el-col>
			<el-col :span="12">
				<span>备注 :</span>
				<span>{{row.remark}}</span>
			</el-col>
			<el-col :span="24">物品信息</el-col>
			<el-table :data="row.bdMaterialDetailsList" style="width: 100%" border>
				<el-table-column label="序号" type="index" align="center" width="50"></el-table-column>
				<el-table-column label="型号" prop="model" align="center"></el-table-column>
				<el-table-column label="数量" prop="num" align="center"></el-table-column>
				<el-table-column label="名称" prop="name" align="center"></el-table-column>
				<el-table-column label="备注" prop="remark" align="center"></el-table-column>
				<el-table-column label="操作" align="center">
					<template slot-scope="{row}">
						<el-button type="text" @click="getRow(row)">详情</el-button>
					</template>
				</el-table-column>
			</el-table>
		</el-row>
		<el-row :gutter="20" v-if="row.processKey=='complaintProcess'">
			<el-col :span="12">
				<span>投诉反馈 :</span>
				<span>{{row.opinion}}</span>
			</el-col>
			<el-col :span="12">
				<span>联系电话 :</span>
				<span>{{row.phone}}</span>
			</el-col>
			<el-col :span="12">
				<span>投诉原因 :</span>
				<span>{{row.reson}}</span>
			</el-col>
			<el-col :span="12">
				<span>投诉时间 :</span>
				<span>{{row.time}}</span>
			</el-col>
		</el-row>
		<el-row :gutter="20" v-if="row.processKey=='serviceProcess'">
			<el-col :span="12">
				<span>申请人名称 :</span>
				<span>{{row.username}}</span>
			</el-col>
			<el-col :span="12">
				<span>服务项目名称 :</span>
				<span>{{row.projectName}}</span>
			</el-col>
			<el-col :span="12">
				<span>服务要求 :</span>
				<span>{{row.serviceDescribe}}</span>
			</el-col>
			<el-col :span="12">
				<span>上门时间 :</span>
				<span>{{row.visitStartTime}}</span>
			</el-col>
			<el-col :span="12">
				<span>离开时间 :</span>
				<span>{{row.visitEndTime}}</span>
			</el-col>
			<el-col :span="12">
				<span>联系电话 :</span>
				<span>{{row.phone}}</span>
			</el-col>
			<el-col :span="12">
				<span>留言 :</span>
				<span>{{row.leaveMessage}}</span>
			</el-col>
			<el-col :span="12">
				<span>房间号 :</span>
				<span>{{row.roomNumber}}</span>
			</el-col>
			<el-col :span="12">
				<span>结果 :</span>
				<span>{{row.result}}</span>
			</el-col>
			<el-col :span="12">
				<span>客服姓名 :</span>
				<span>{{row.approvalName}}</span>
			</el-col>
			<el-col :span="12">
				<span>状态 :</span>
				<span>{{row.status}}</span>
			</el-col>
			<el-col :span="12">
				<span>申请时间 :</span>
				<span>{{row.createTime}}</span>
			</el-col>
			<el-col :span="12">
				<span>修改时间 :</span>
				<span>{{row.updateTime}}</span>
			</el-col>
			<el-col :span="12">
				<span>服务名称 :</span>
				<span>{{row.bdServiceProject?row.bdServiceProject.name:""}}</span>
			</el-col>
			<el-col :span="12">
				<span>描述 :</span>
				<span>{{row.bdServiceProject?row.bdServiceProject.describes:""}}</span>
			</el-col>
			<el-col :span="12">
				<span>服务类型（普通，特殊） :</span>
				<span>{{row.bdServiceProject?row.bdServiceProject.type:""}}</span>
			</el-col>
		</el-row>
		<el-row :gutter="20" v-if="row.processKey=='repairProcess'">
			<el-col :span="12">
				<span>申请人名称 :</span>
				<span>{{row.username}}</span>
			</el-col>
			<el-col :span="12">
				<span>报修项目名称 :</span>
				<span>{{row.projectName}}</span>
			</el-col>
			<el-col :span="12">
				<span>故障区域 :</span>
				<span>{{row.faultArea}}</span>
			</el-col>
			<el-col :span="12">
				<span>故障描述 :</span>
				<span>{{row.faultDescribe}}</span>
			</el-col>
			<el-col :span="12">
				<span>上门起始时间 :</span>
				<span>{{row.visitStartTime}}</span>
			</el-col>
			<el-col :span="12">
				<span>上门截止时间 :</span>
				<span>{{row.visitEndTime}}</span>
			</el-col>
			<el-col :span="12">
				<span>联系电话 :</span>
				<span>{{row.phone}}</span>
			</el-col>
			<el-col :span="12">
				<span>留言 :</span>
				<span>{{row.leaveMessage}}</span>
			</el-col>
			<el-col :span="12">
				<span>房间号 :</span>
				<span>{{row.roomNumber}}</span>
			</el-col>
			<el-col :span="12">
				<span>结果 :</span>
				<span>{{row.result}}</span>
			</el-col>
			<el-col :span="12">
				<span>状态 :</span>
				<span>{{row.status}}</span>
			</el-col>
			<el-col :span="12">
				<span>催单 :</span>
				<span>{{row.reminder}}</span>
			</el-col>
			<el-col :span="12">
				<span>项目名称 :</span>
				<span>{{row.bdRepairProject?row.bdRepairProject.name:""}}</span>
			</el-col>
			<el-col :span="12">
				<span>描述 :</span>
				<span>{{row.bdRepairProject?row.bdRepairProject.describes:""}}</span>
			</el-col>
			<el-col :span="12">
				<span>故障图片 :</span>
				<img :src="row.showPath">
			</el-col>
		</el-row>
		<el-row :gutter="20" v-if="row.processKey=='checkApplyProcess'">
			<el-col :span="12">
				<span>人才名称 :</span>
				<span>{{row.name}}</span>
			</el-col>
			<el-col :span="12">
				<span>单位 :</span>
				<span>{{row.company}}</span>
			</el-col>
			<el-col :span="12">
				<span>房间号 :</span>
				<span>{{row.roomNumber}}</span>
			</el-col>
			<el-col :span="12">
				<span>原因 :</span>
				<span>{{row.reason}}</span>
			</el-col>
			<el-col :span="12">
				<span>状态 :</span>
				<span>{{row.status}}</span>
			</el-col>
			<el-col :span="12">
				<span>申请类型 :</span>
				<span>{{row.applyType}}</span>
			</el-col>
			<el-col :span="12">
				<span>申请时间 :</span>
				<span>{{row.createTime}}</span>
			</el-col>
			<el-col :span="12" v-if="row.applyType=='换房'">
				<span>修改的房间号 :</span>
				<span>{{row.newRoomNumber}}</span>
			</el-col>
			<el-col :span="12" v-if="row.applyType=='退房'">
				<span>退房期限 :</span>
				<span>{{row.term}}</span>
			</el-col>
		</el-row>

		<el-row :gutter="20" v-if="row.processKey=='checkInProcess'">
			<el-col :span="12">
				<span>人才姓名 :</span>
				<span>{{row.name}}</span>
			</el-col>
			<el-col :span="12">
				<span>所属单位 :</span>
				<span>{{row.company}}</span>
			</el-col>
			<el-col :span="12">
				<span>房间号 :</span>
				<span>{{row.roomNum}}</span>
			</el-col>
			<el-col :span="12">
				<span>手机号 :</span>
				<span>{{row.phone}}</span>
			</el-col>
			<el-col :span="12">
				<span>入住日期 :</span>
				<span>{{new Date(parseInt(row.checkInTime)).toLocaleDateString()}}</span>
			</el-col>
			<el-col :span="12">
				<span>截止日期 :</span>
				<span>{{new Date(parseInt(row.endTime)).toLocaleDateString()}}</span>
			</el-col>
			<el-col :span="12">
				<span>其他成员 :</span>
				<span>{{row.members}}</span>
			</el-col>
			<el-col :span="12">
				<span>入住要求 :</span>
				<span>{{row.requirement}}</span>
			</el-col>
			<!-- <el-col :span="12" v-if="row.applyType=='换房'">
				<span>修改的房间号 :</span>
				<span>{{row.newRoomNumber}}</span>
			</el-col>
			<el-col :span="12" v-if="row.applyType=='退房'">
				<span>退房期限 :</span>
				<span>{{row.term}}</span>
			</el-col> -->
			<slot name="rzsq"></slot>
		</el-row>


	</div>
</template>

<script>
	export default {
		props: {
			row: {
				default: {}
			}
		}
	}
</script>

<style>
</style>
